import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'

// Design Style Sheet
import '@/assets/styles/default.css'
import '@/assets/styles/colors.css'
import '@/assets/styles/fonts.css'

// Language
import ko from '@/assets/strings/ko.json'

store.commit('setLang', ko)

// Launch
createApp(App).use(Quasar, quasarUserOptions).use(store).use(router).mount('#app')
